import { render, staticRenderFns } from "./knjy.vue?vue&type=template&id=75bb3f3d&scoped=true"
import script from "./knjy.vue?vue&type=script&lang=js"
export * from "./knjy.vue?vue&type=script&lang=js"
import style0 from "./knjy.vue?vue&type=style&index=0&id=75bb3f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb3f3d",
  null
  
)

export default component.exports